export default __webpack_public_path__ + "static/media/top_bar.717653f0.png";